<template lang="pug">
div
    nav(:class="[color, {opened: dropdownOpened}]")
        div.container
            transition(name="fade")
                div.nav(v-show="!dropdownOpened")
                    router-link.menu(:to="getLocalizedUrl($store.state.links[key].url)" v-for="key in menu" :key="key") {{ $t($store.state.links[key].name) }}
                    span.current-category(v-if="!!$store.state.category") {{ $store.state.category.name[$i18n.locale] }}
            div.logo
                router-link.menu.bold(:to="getLocalizedUrl($store.state.links.main.url)" @close.native="changeDropdownState(false)") Sota.
            div.icon(@click="changeDropdownState(!dropdownOpened)")
                svg(width="25" height="25" viewBox="0 0 25 25")
                    transition(name="fade")
                        path(fill="#000" v-if="!dropdownOpened" key="open" fill-rule="evenodd" d="M1 5.5h23v2H1v-2zm0 6h23v2H1v-2zm0 6h23v2H1v-2z")
                        g(fill="none" v-else key="close" fill-rule="evenodd" stroke="#000" stroke-width="1.5")
                            path(d="M5 5l15 15M5 20L20 5")
    transition(name="fade")
        div#navdropdown.dropdown(v-show="dropdownOpened")
            div.overlay(@click="changeDropdownState(false)")
            div.content
                div.container
                    component(:is="currentDropdownComponent" @close="changeDropdownState(false)")
</template>

<script>
import scrollDoc from 'scroll-doc'
import smoothScroll from 'smoothscroll'

const page = scrollDoc()

import FullMenu from '../menu/Fullmenu.vue'
import UserForm from '../menu/UserForm.vue'

export default {
    name: 'navbar',
    props: {
        color: {
            type: String,
            default: "white"
        }
    },
    data () { 
        return {
            dropdownOpened: false,
            currentDropdownComponent: 'fullmenu',
            menu: ["projects", "studio", "blog", "contacts"]
        }
    },
    watch: {
        dropdownOpened() {
            if (this.dropdownOpened)
                document.body.classList.add("mobile-menu-opened")
            else
                document.body.classList.remove("mobile-menu-opened")
        }
    },
    created: function() {
        this.$bus.$on('open-form', this.openForm)
    },
    methods: {
        changeDropdownState: function(state, component="fullmenu") {
            page.hdl = this;
            this.currentDropdownComponent = component;
            if (state) {
                if(this.currentDropdownComponent == "fullmenu" || window.innerWidth > 576)   
                    document.documentElement.style.overflowY = "hidden";
                smoothScroll(0, (this.currentDropdownComponent == "fullmenu" ? 50 : 200), function() {
                    page.hdl.dropdownOpened = state;
                })
            } else {
                this.dropdownOpened = state;
                document.documentElement.style.overflowY = "auto";
            }
        },
        openForm: function() {
            this.changeDropdownState(true, "userform");
        }
    },
    components: {
        'fullmenu': FullMenu,
        'userform': UserForm
    }
}
</script>

<style lang="scss">
@import "@styles/mixins.scss";
$navbar-height: 70px;
body.mobile-menu-opened {
    position: fixed;
    width: 100%;
    height: 100%;
}
nav {
    height: $navbar-height;
    position: relative;
    z-index: 1000;
    .current-category {
        display: none;
    }
    &.black {
        border-bottom: solid 1px rgba(0, 0, 0, 0.1);
        a { color: black; }
        .icon svg g { stroke: #000; }
        .icon svg path { fill: #000; }
    }
    &.white {
        border-bottom: solid 1px rgba(255, 255, 255, 0.2);
        a { color: white; }
        .icon svg g { stroke: #fff; }
        .icon svg path { fill: #fff; }
    }
    .container > div { display: inline-block; }
    @media (max-width: grid-breakpoint(sm)) {
        height: 55px;
    }
}
.nav {
    margin-top: 20px;
    .menu {margin-right: 20px;}
    .router-link-exact-active {color: $color-sotayellow;}
    @media (max-width: grid-breakpoint(sm)) {
        position: absolute;
        right: 63px;
        margin-top: 16px;
        .menu { display: none; }
        .router-link-exact-active, .current-category {
            display: inline-block;
            margin-right: 0;
        }
        nav.black & .router-link-exact-active, nav.black & .current-category {
            color: black;
            opacity: 0.4;
        }
        nav.white & .router-link-exact-active, nav.white & .current-category {
            color: white;
            opacity: 0.6;
        }
    }
}
.icon {
    float: right;
    margin-top: 22.5px;
    cursor: pointer;
    &:hover svg g { stroke: $color-sotayellow!important; }
    &:hover svg path { fill: $color-sotayellow!important; }
    @media (max-width: grid-breakpoint(sm)) {
        margin-top: 15px;
    }
}
.logo {
    position: absolute;
    left: 50%;
    margin-left: -25px;
    padding-top: 20px;
    width: 50px;
    text-align: center;
    @media (max-width: grid-breakpoint(lg)) {
        left: auto;
        right: 63px;
    }
    @media (max-width: grid-breakpoint(sm)) {
        left: 40px;
        right: auto;
        padding-top: 13px;
        margin-left: -20px;
        a {
            font-size: 22px;
            line-height: 30px;
            letter-spacing: -.5px;  
        }
    }
}
.dropdown {
    position: absolute;
    z-index: 999;
    width: 100%;
    top: $navbar-height;
    overflow-y: auto;
    overflow-x: hidden;
    bottom: 0;
    @media (max-width: grid-breakpoint(sm)) {
        top: 55px;
    }
    .overlay {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
    }
    .content {
        position: relative;
        background-color: #ffffff;
        box-shadow: 0 24px 24px 0 rgba(0, 0, 0, 0.5);
        padding-top: 100px;
        padding-bottom: 100px;
        @media (max-width: grid-breakpoint(lg)) {
            min-height: 100%;
            padding-top: 60px;
        }
        @media (max-width: grid-breakpoint(sm)) {
            padding-top: 0;
            padding-bottom: 60px;
            display: table;
            .container {
                display: table-cell;
                vertical-align: middle;
            }
        }
    }
}
nav, .dropdown {
    a, h3, .icon {
        @include select-none();
    }
}
nav {
    .logo a { transition: color .3s; }
    .icon svg g { transition: stroke .3s; }
    .icon svg path { transition: fill .3s; }
    transition: background-color .3s cubic-bezier(0.39, 0.575, 0.565, 1);
    &.opened {
        background-color: white;
        border-bottom: solid 1px rgba(0, 0, 0, 0.1);
        .logo a { color: black; }
        .icon svg g { stroke: #000; }
        .icon svg path { fill: #000; }
    }
}
</style>
